import { render, staticRenderFns } from "./payTypeLayer.vue?vue&type=template&id=6662f04a&"
import script from "./payTypeLayer.vue?vue&type=script&lang=js&"
export * from "./payTypeLayer.vue?vue&type=script&lang=js&"
import style0 from "./payTypeLayer.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports